import { usesMobileApp } from "@/lib/mobile-app";

// Where an authenticated user lands by default. The lean Agent app (Capacitor or
// a phone-sized website/PWA) opens on the Agent chat surface. The full app sends
// the user to the index dispatcher (`/`), which reads their `default_page` flag
// and forwards to the chosen page (home, recap, …). Runtime-evaluated because it
// depends on the viewport.
export function defaultAuthenticatedRoute(): string {
  return usesMobileApp() ? "/ai" : "/";
}

// Where to send a user who lands on `/home` while the home page is disabled
// (the `sidebarShowHome` flag is off). Must be a non-home route so the
// dispatcher → /home → fallback path can never loop back onto itself. Recap is
// the product's primary surface, so it's the safe universal fallback.
export const HOME_DISABLED_FALLBACK = "recap";

// Transport-mode URL remap. Certain pages have a transport sibling that
// replaces them when the `transportMode` flag is on — today only recap, whose
// sibling is `/recap_transport`. Keyed by page id (the sidebar item id, which
// is also the `default_page` value), valued by the sibling path.
//
// Single source of truth shared by the sidebar (rewrites its entry URLs) and
// the `/` dispatcher (rewrites the resolved landing page), so first-login lands
// on the transport surface just like clicking the sidebar entry would.
export const TRANSPORT_URL_MAP: Record<string, string> = {
  recap: "/recap_transport",
};

// Resolve a landing-page id (e.g. `"recap"`, as produced by the `/` dispatcher)
// to the path to navigate to, applying the transport remap when transport mode
// is on. Returns a leading-slash path.
export function resolveLandingPath(
  pageId: string,
  transportMode: boolean,
): string {
  if (transportMode && TRANSPORT_URL_MAP[pageId]) {
    return TRANSPORT_URL_MAP[pageId];
  }
  return `/${pageId}`;
}
